import { Checkbox as MUICheckbox, FormControlLabel, FormControlLabelProps } from '@mui/material'
import { FieldContainer } from '../functional'
import styled from '@emotion/styled'
import { color, font } from '../../styles'

type CheckboxProps = Omit<FormControlLabelProps, 'control'> & {
   name: string
}

const Checkbox: React.FC<CheckboxProps> = ({ name, label, ...props }) => {
   return (
      <FieldContainer name={name}>
         {({ helperText, error, ...fieldProps }) => (
            <Holder>
               <FormControlLabel
                  name={name}
                  // @ts-ignore
                  control={<MUICheckbox {...fieldProps} {...props} checked={fieldProps.value} />}
                  label={label}
               />
            </Holder>
         )}
      </FieldContainer>
   )
}
const Holder = styled.div`
   label {
      user-select: none;
      .MuiTypography-root {
         color: ${color.grayDark};
         ${font.thin};
      }
   }
`
export default Checkbox
